// extracted by mini-css-extract-plugin
export default {"card":"_2GBI_1AD","heading":"k89GSaaJ","subline":"_2iMlSQZc","chipRow":"_3QbJST5x","chip":"_2W0k6cMA","chipLabel":"_32Q8Vu7L","chipRemove":"_2W5PzmLJ","clearAll":"_3bWzzcQL"};